<script>
	import { Col, Row, Button, Image } from "@sveltestrap/sveltestrap";
	import { driveDamageTypeOptions } from "../../../../../utils/options";
	import { issueDetail, imageLightbox } from "../../../../../store/store";
	//Lightbox for image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";

	let typeName = $issueDetail.driveIssues;
	let imgUrl = [];
	$: image = imgUrl;

	for (const key in typeName) {
		if (typeName.hasOwnProperty(key)) {
			typeName[key].forEach((element) => {
				imgUrl.push({
					url: element,
					text: key,
				});
			});
		}
	}

	$: damageType = "All";

	const handleChange = (value) => {
		if (value === "All") {
			imgUrl = [];
			for (const key in typeName) {
				if (typeName.hasOwnProperty(key)) {
					typeName[key].forEach((element) => {
						imgUrl.push({
							url: element,
							text: key,
						});
					});
				}
			}
			image = imgUrl;
		} else {
			let dataUrl = $issueDetail.driveIssues[value];
			let arrImg = [];
			dataUrl.forEach((element) => {
				arrImg.push({
					url: element,
					text: value,
				});
			});

			image = arrImg;
		}
	};

	let modalOpen = false;
	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		let arrImg = [];
		let img = image.map((url) => {
			arrImg.push(url.url);
		});
		imageLightbox.set([]);
		imageShowingIndex = Number(i);
		modalOpen = true;
		imageLightbox.set(arrImg);
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}
<Col xs={12}>
	<div class="mw-100">
		<Row class="carousel-detail-image mb-4  overflow-auto">
			<Col class="row d-flex pe-1">
				<div class="ps-3 pt-3">
					<h6>Total record: <b>{image.length} image(s)</b></h6>
				</div>
				<div class="ps-3 py-3">
					<div>
						{#each image as { url, text }, index}
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<div
								class="container-checkbox link"
								style="height:auto; border: 0px !important; padding: 5px !important;
				outline: 0 !important; "
								on:click={() => handleImgClick(index)}
							>
								<Image
									src={url}
									style="width:100%; height:400px; object-fit: scale;"
									alt="vehicle image"
								/>
								<span><b>{text}</b></span>
							</div>
						{/each}
					</div>
				</div>
			</Col>
		</Row>
	</div>
</Col>
<Col xs={12} class="my-2">
	<Col xxl={12} class="my-4">
		<Row class="my-3">
			<Col>
				<span>Damage Type </span>
			</Col>
			<Col xs={9}>
				<div>
					<label
						key={`option-driveDamageType-6`}
						class="customCheckbox-new ms-2"
					>
						<input
							type="radio"
							name="driveDamageType"
							value="All"
							class="d-none input"
							on:change={() => handleChange("All")}
							bind:group={damageType}
						/>
						<span class="customCheckbox-content-new py-1 mb-2">
							All
						</span>
					</label>
					{#each driveDamageTypeOptions as { name, value, label }, key}
						<label
							key={`option-${name}-${key + 1}`}
							class="customCheckbox-new ms-2"
						>
							<input
								type="radio"
								{name}
								{value}
								class="d-none input"
								bind:group={damageType}
								on:change={() => handleChange(value)}
								disabled={!$issueDetail.driveIssues.hasOwnProperty(
									value
								)}
							/>
							<span
								class="{!$issueDetail.driveIssues.hasOwnProperty(
									value
								)
									? 'customCheckbox-content-new-disabled'
									: 'customCheckbox-content-new'} py-1 mb-2"
							>
								{label}
							</span>
						</label>
					{/each}
				</div>
			</Col>
		</Row>
	</Col>
</Col>

<style>
	.container-checkbox {
		position: relative;
		float: left;
		width: 50%;
		padding: 5px;
	}

	:global(.carousel-detail-image) {
		border: 0.5px solid gray;
		margin-left: 10px !important;
		margin-right: 10px !important;
		border-radius: 0.375rem;
		overflow: hidden;
		height: 600px;
	}
</style>
